
import {Component, Prop, VModel, Vue, Watch} from "vue-property-decorator";

@Component({})
export default class NumberInput extends Vue {
  @VModel({})
  public modelValue!: number | string;

  @Prop({})
  protected path!: string;

  @Prop({})
  protected properties!: {
    html: {},
    readonly?: boolean,
    disabled?: boolean,
    options?: object,
    hint?: string
  };

  @Prop({})
  protected success!: object[];

  @Prop({})
  protected error!: object[];

  //local variables
  protected disabled: boolean = false;
  protected readonly: boolean = false;
  protected html: object = {};
  protected hint: string = '';

  //error and success
  protected localSuccess: boolean = false;
  protected localError: boolean = false;
  protected localErrorMessages: string[] = [];

  @Watch('error')
  public watcherForErrors() {
    this.localError = this.checkIfExistInList(this.path, this.error);
  }


  @Watch('success')
  public watcherForSuccess() {
    this.localSuccess = this.checkIfExistInList(this.path, this.success)
  }

  // setTel(v) {
  //     this.modelValue = this.modelValue.replace(/[^0-9]/g, "");
  // }

  mounted() {
    if (typeof this.modelValue === 'string') {
      this.modelValue = parseInt(this.modelValue);
    }

    if (this.properties.disabled) {
      this.disabled = this.properties.disabled;
    }

    if (this.properties.readonly) {
      this.readonly = this.properties.readonly;
    }
    if (this.properties?.hint) {
      this.hint = this.properties?.hint;
    }

    this.html = this.properties.html;
  }

  checkIfExistInList(ID: string, array: object[]) {
    let inArray = false;
    array.forEach((item: object) => {
      if (item.key === ID) {
        inArray = true;
        if ('message' in item) {
          this.localErrorMessages = item.message;
        }
      }
    })

    return inArray;
  }

  /**
   * Force setTel tp replace, FIx function.
   *
   * OF
   *                 :rules="[
   *                  v  => {
   *                         if (!v.trim()) return true;
   *                         if (!isNaN(parseFloat(v))) return true;
   *                         return 'input must be valid number.'
   *                       }
   *                 ]"
   */
}
